/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EncounterStatus = {
    Planned: 'planned',
    InProgress: 'in-progress',
    Completed: 'completed',
    Cancelled: 'cancelled',
} as const;
export type EncounterStatus = typeof EncounterStatus[keyof typeof EncounterStatus];


export function instanceOfEncounterStatus(value: any): boolean {
    for (const key in EncounterStatus) {
        if (Object.prototype.hasOwnProperty.call(EncounterStatus, key)) {
            if (EncounterStatus[key as keyof typeof EncounterStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EncounterStatusFromJSON(json: any): EncounterStatus {
    return EncounterStatusFromJSONTyped(json, false);
}

export function EncounterStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EncounterStatus {
    return json as EncounterStatus;
}

export function EncounterStatusToJSON(value?: EncounterStatus | null): any {
    return value as any;
}

export function EncounterStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EncounterStatus {
    return value as EncounterStatus;
}

